import React from 'react'
import ReactDOM from 'react-dom/client'
import { ChakraProvider } from '@chakra-ui/react'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import theme from './theme'
import { AuthProvider } from './context/AuthContext'
import './index.css'

import { WebSocketProvider } from './context/WebSocketContext'
import { NotificationProvider } from './context/NotificationContext'
import ErrorBoundary from './components/ErrorBoundary'

import { GPSProvider } from './context/GPSContext'

// ...

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      <ErrorBoundary>
        <BrowserRouter>
          <AuthProvider>
            <WebSocketProvider>
              <NotificationProvider>
                <GPSProvider>
                  <App />
                </GPSProvider>
              </NotificationProvider>
            </WebSocketProvider>
          </AuthProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </ChakraProvider>
  </React.StrictMode>,
)
